<template>
  <div class="reward-flow-wrap" :class="{ 'is-mobile': $store.getters.isMobile }" :style="wrapStyle">
    <div class="reward-flow">
      <div v-for="(row, rIdx) in rows" :key="`row-${rIdx}`" class="flow-row" :class="{ rtl: rIdx % 2 === 1 }"
        :style="rowStyle()">
        <div v-for="(item, cIdx) in row" :key="`cell-${rIdx}-${cIdx}`" class="cell ltr">
          <bg-style class="card" :bg="model.cardBackground" :radius="model.radius" :style="cardStyle"
            :class="[item.status, { 'no-shadow': model.cardShadow === 0, 'has-detail': hasDetail(item) }]"
            @click.native="handleCardClick(item)">
            <!-- <div v-if="item.locked" class="locked-badge"><i class="el-icon-lock"></i><span>锁定</span></div> -->
            <div class="items-scroll">
              <div class="items-grid"
                :class="{ few: item?.displayItems?.length < 3, 'once': item?.displayItems?.length === 1 }"
                :style="gridStyle(item?.displayItems?.length)">
                <bg-style v-for="(equip, eIdx) in item?.displayItems" :key="eIdx" :radius="model.radius"
                  :bg="model.logoBackground" class="equip">
                  <span class="name">{{ equip.name }}</span>
                  <img class="relative" :src="equip.logo" alt="equip" />
                  <span class="count">{{ equip.num }}</span>
                </bg-style>
              </div>
            </div>
            <bg-style class="footer relative" :radius="model.radius"
              :bg="isOperable(item) ? model.operableButtonBackground : model.inoperableButtonBackground"
              :data-status="item.status_name"
              :data-operable="isOperable(item)" :class="{ 'is-loading': loading && loadingKey === (rIdx + '-' + cIdx), locked: item.locked }"
              @click.native.stop="handleClick(item, rIdx, cIdx)">
              <div class="relative flex items-center justify-center" :class="{'locked': item.locked}">
                <span v-if="item.status_name === QuenUnlockStatusEnum.Purchased">{{ $t('siteBuild.purchased') }}</span>
                <span v-else-if="item.status_name === 'claimed'">{{ $t('siteBuild.activity.haveGet') }}</span>
                <span v-else-if="item.status_name === 'free'">{{ $t('siteBuild.free') }}</span>
                <span v-else-if="item.status_name === 'priced'">{{ item.goods.priceInfo.priceTxt }}</span>
                <i v-if="[QuenUnlockStatusEnum.Priced, QuenUnlockStatusEnum.Free].includes(item.status_name) && loading && loadingKey === (rIdx + '-' + cIdx)"
                  class="el-icon-loading loading-icon"></i>
                <img v-if="item.locked && model.lockBackground?.backgroundImageShow" class="lock" :src="model.lockBackground?.backgroundImage" alt />
              </div>
            </bg-style>
            <div v-if="arrowForLocal(rIdx, cIdx, row.length)" class="arrow" :style="arrowStyle"
              :class="[`arrow-${arrowForLocal(rIdx, cIdx, row.length)}`, { 'arrow-nudge': shouldNudge(rIdx, cIdx, row.length) }]">
              <img :src="model.arrowBackground?.backgroundImage" :class="arrowForLocal(rIdx, cIdx, row.length)" alt />
            </div>
          </bg-style>
        </div>
      </div>
    </div>
    <desk-pay-modal v-if="deskPay.visible" :desk-pay="deskPay" :lang-id-data="$store.state.locale.langIdData"
      @close="closePay" />
    <RewardInfoDialog ref="info" :data="currentDetail" />
  </div>
</template>

<script>
import { Message } from 'element-ui';
import { cloneDeep } from 'lodash-es';
import { computeBackgroundStyle } from '~/site/model/helper'
import { QueryKey } from '~/enums/tanstack'
import DeskPayModal from '~/components/pay/deskPayModal.vue'
import RewardInfoDialog from '~/components/common/RewardInfoDialog.vue'
import { getTextColor, generatePayUrl, generateOrderParams, checkUser, getLangIdI18n } from '~/utils'
import { QuenUnlockStatusEnum, TypeData, BusEventMap } from '~/enums/data';
import Bus from "~/site/model/bus";

export default {
  name: 'RewardFlow',
  components: {
    DeskPayModal,
    RewardInfoDialog
  },
  props: {
    model: { type: Object, default: () => ({}) },
    editing: { type: Boolean, default: false },
    activityId: { type: [String, Number], default: null },
    steps: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      QuenUnlockStatusEnum,
      isMobile: false,
      loading: false,
      loadingKey: '',
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      },
      currentDetail: {}
    }
  },
  computed: {
    wrapStyle() {
      const shadowBlur = this.model?.cardShadow === undefined ? 10 : this.model.cardShadow
      return {
        '--border-radius': (this.model?.radius || 12) + 'px',
        '--card-shadow-val': shadowBlur === 0 ? 'none' : `0 2px ${shadowBlur}px rgba(0, 0, 0, 0.08)`,
        '--operable-color': getTextColor(this.model.operableButtonTextColor)?.color,
        '--inoperable-color': getTextColor(this.model.inoperableButtonTextColor)?.color,
        '--name-color': getTextColor(this.model.textColor)?.color
      }
    },
    normalizedSteps() {
      const langIdData = this.$store.state.locale.langIdData
      return this.steps.map(s => {
        const newItem = { ...s }
        newItem.locked = ![QuenUnlockStatusEnum.Purchased, QuenUnlockStatusEnum.Claimed].includes(newItem.status_name) && newItem.status !== 2
        newItem.displayItems = []
        if (!newItem.free) {
          if (newItem.goods.contents) {
            newItem.displayItems = newItem.goods?.contents.map(i => ({
              logo: i.icon,
              num: i.num,
              name: getLangIdI18n({ lang_id: i.name }, langIdData)
            }))
          } else {
            newItem.displayItems.push({
              logo: newItem.goods.icon,
              num: 1,
              name: getLangIdI18n({ lang_id: newItem.goods.name }, langIdData)
            })
          }
        } else {
          newItem.displayItems = newItem.gifts.map(i => ({
            logo: i.logo,
            num: i.num,
            name: getLangIdI18n({ lang_id: i.gift_goods_name }, langIdData)
          }))
        }
        return newItem
      })
    },
    rows() {
      const res = []
      const list = this.normalizedSteps
      console.log(list)
      const effectiveCols = this.$store.getters.isMobile ? 2 : 4
      for (let i = 0; i < list.length; i += effectiveCols) {
        res.push(list.slice(i, i + effectiveCols))
      }
      return res
    },
    cardStyle() {
      const { customStyle } = computeBackgroundStyle(this.model?.cardBackground || {})
      const r = (this.model?.radius || 12) + 'px'
      return Object.assign({}, customStyle || {}, { borderRadius: r })
    },
    footerStyle() {
      return (item) => {
        const operable = this.isOperable(item)
        const bgModel = operable ? this.model?.operableButtonBackground : this.model?.inoperableButtonBackground
        const { customStyle } = computeBackgroundStyle(bgModel || {})
        const textModel = operable ? this.model?.operableButtonTextColor : this.model?.inoperableButtonTextColor
        const color = getTextColor(textModel || {}).color
        const r = (this.model?.radius || 12) + 'px'
        const style = Object.assign({}, customStyle || {}, { borderRadius: r })
        if (color) style.color = color
        return style
      }
    },
    arrowStyle() {
      const color = getTextColor(this.model?.arrowBackground || {}).color
      return color ? { color } : {}
    },
    showTitle() {
      return this.model?.titleVisible !== false
    },
    showGroupName() {
      return this.model?.groupNameVisible !== false
    }
  },
  methods: {
    isOperable(item) {
      return item.status === 2 && [QuenUnlockStatusEnum.Priced, QuenUnlockStatusEnum.Free].includes(item.status_name)
    },
    hasDetail(item) {
      if (item.free && item.gifts?.length) return true
      if (!item.free && item.goods?.contents?.length) return true
      return false
    },
    handleCardClick(item) {
      if (this.editing || !this.hasDetail(item)) return
      const giftList = []
      if (item.free && item.gifts?.length) {
        item.gifts.forEach((g) => {
          giftList.push({
            gift_goods_logo: g.logo,
            gift_goods_name: g.gift_goods_name,
            num: g.num,
            level_icon: g.level_icon
          })
        })
      } else if (!item.free && item.goods?.contents?.length) {
        item.goods.contents.forEach((c) => {
          giftList.push({
            gift_goods_logo: c.icon,
            gift_goods_name: c.name,
            num: c.num,
            level_icon: c.level_icon
          })
        })
      } else {
        return
      }
      this.currentDetail = { gift_list: giftList }
      this.$refs.info.init()
    },
    closePay() {
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      this.$utils.emitRefreshProjectVip()
      Bus.$emit(BusEventMap.RefreshLottery)
      this.$emit('close')
    },
    async createOrder(data) {
      this.loading = true
      const [err, res] = await this.$utils.to(generateOrderParams(this, data, TypeData.rollingOffer))
      this.loading = false
      this.loadingKey = ''
      if (!err) {
        if (res.token) {
          this.$store.commit('site/SET_AWAIT_GOODS', null)
          generatePayUrl(res, this)
        } else {
          Message.success('Success')
          this.closePay()
        }
      } else {
        Message.error(err)
      }
    },
    async handleClick(record, rIdx, cIdx) {
      if (record.locked && !this.editing) {
        Message.error(this.$t('siteBuild.quenUnlockTip'))
      } else if (this.isOperable(record)) {
        if (this.editing || this.loading) return
        this.loadingKey = rIdx + '-' + cIdx
        const newGoods = cloneDeep({
          ...record.goods,
          prices_setting: record?.goods?.price_setting || {},
          activity_id: this.activityId || this.model.bizId,
          level_id: record.id
        })
        await checkUser(this, () => {
          this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, data: newGoods })
        })

        await this.createOrder(newGoods)
      }
    },
    // 计算箭头指向的目标卡片（蛇形布局：奇数行向右，偶数行向左；行末/行首向下）
    arrowTarget(rowIndex, colIndex, rowLen, dir) {
      const oddVisualRow = rowIndex % 2 === 0
      const nextRow = this.rows[rowIndex + 1] || null
      if (dir === 'right') {
        return this.rows[rowIndex][colIndex + 1] || null
      }
      if (dir === 'left') {
        return this.rows[rowIndex][colIndex - 1] || null
      }
      if (dir === 'down') {
        if (!nextRow) return null
        return oddVisualRow ? nextRow[nextRow.length - 1] : nextRow[0]
      }
      return null
    },
    shouldNudge(rowIndex, colIndex, rowLen) {
      const colLastIndex = this.$store.getters.isMobile ? 1 : 3
      let next = this.rows[rowIndex]?.[colIndex + 1]
      if (colIndex === colLastIndex && this.rows[rowIndex + 1]) {
        next = this.rows[rowIndex + 1]?.[0]
      }
      return next?.status === 2
    },
    rowStyle() {
      const effectiveCols = this.$store.getters.isMobile ? 2 : 4
      return { '--cols': effectiveCols }
    },
    gridStyle(count) {
      // 小于 3 个道具时，按实际数量设置列数以水平居中
      if (count < 3) {
        return { gridTemplateColumns: `repeat(${count}, var(--equip-size))` }
      }
      return {}
    },
    arrowForLocal(rowIndex, colIndex, rowLen) {
      const oddVisualRow = rowIndex % 2 === 0 // 视觉奇数行（第1、3…）从左到右
      const nextRowExists = rowIndex < this.rows.length - 1 && (this.rows[rowIndex + 1] || []).length > 0
      const isVisualFirst = oddVisualRow ? colIndex === 0 : colIndex === rowLen - 1
      const isVisualLast = oddVisualRow ? colIndex === rowLen - 1 : colIndex === 0

      // 向下箭头：奇数行视觉末卡、偶数行视觉首卡（仅当下一行存在）
      if (oddVisualRow && isVisualLast) return nextRowExists ? 'down' : null
      if (!oddVisualRow && isVisualFirst) return nextRowExists ? 'down' : null

      // 行内方向：奇数行向右、偶数行向左
      return oddVisualRow ? 'right' : 'left'
    }
  }
}
</script>

<style lang="less" scoped>
.reward-flow-wrap {
  position: relative;
  .flow-header {
    text-align: center;
    margin-bottom: 18px;

    .flow-title {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    .flow-desc {
      p {
        margin: 2px 0;
        color: #666;
        font-size: 14px;
      }
    }
  }

  .reward-flow {
    --row-gap: 40px;
    --card-width: 275px; // 固定卡片宽度（桌面）
    display: flex;
    flex-direction: column;
    gap: var(--row-gap);

    .flow-row {
      --col-gap: 40px;
      --cols: 4;
      display: grid;
      grid-template-columns: repeat(var(--cols), var(--card-width));
      column-gap: var(--col-gap);

      &.rtl {
        direction: rtl; // 偶数行从右向左自动排布，保持列对齐
      }

      .ltr {
        direction: ltr;
      }

      .cell {
        position: relative;
        flex: 0 0 var(--card-width);
        width: var(--card-width);

        .card {
          position: relative;
          border: 1px solid rgba(0, 0, 0, 0.06);
          padding: 20px 16px 16px 16px;
          box-shadow: var(--card-shadow-val);
          display: flex;
          flex-direction: column;
          height: 300px; // 统一卡片高度
          transition: box-shadow 160ms ease, transform 160ms ease, background 160ms ease;
          will-change: transform, box-shadow;
          cursor: default;

          &.has-detail {
            cursor: pointer;
          }

          &.no-shadow {
            box-shadow: none !important;
          }

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
            background: linear-gradient(180deg, #fff9e6 0%, #fff2bf 100%);
          }

          .locked-badge {
            position: absolute;
            top: 8px;
            right: 12px;
            z-index: 2;
            padding: 2px 8px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 700;
            color: #fff;
            background: rgba(17, 24, 39, 0.85);
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

            i {
              margin-right: 4px;
            }
          }

          .items-scroll {
            flex: 1;
            overflow: auto; // 超出滚动

            &::-webkit-scrollbar {
              width: 8px;
              height: 8px;
              display: none;
            }

            &::-webkit-scrollbar-thumb {
              background: rgba(0, 0, 0, 0.2);
              border-radius: 8px;
            }

            &::-webkit-scrollbar-track {
              background: rgba(0, 0, 0, 0.06);
              border-radius: 8px;
            }
          }

          .items-grid {
            --equip-size: 95px;
            display: grid;
            grid-template-columns: repeat(2, var(--equip-size));
            grid-auto-rows: var(--equip-size);
            gap: 12px;
            justify-content: center;
            height: 100%;

            &.few {
              // 小于 3 个道具时，垂直 & 水平居中
              place-content: center;
            }

            &.once {
              --equip-size: 170px;
            }

            .equip {
              position: relative;
              width: var(--equip-size);
              height: var(--equip-size);
              // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
              display: flex;
              align-items: center;
              justify-content: center;

              // transition: transform 120ms ease, box-shadow 120ms ease;
              .name {
                position: absolute;
                top: 0;
                left: 0;
                font-size: 12px;
                font-weight: 600;
                color: var(--name-color);
                padding: 2px 6px;
                border-radius: 12px;
                line-height: 1.2;
                z-index: 200;
                text-overflow: ellipsis;
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
              }

              img {
                width: 78%;
                height: 78%;
                object-fit: cover;
                border-radius: 8px;
              }

              .count {
                position: absolute;
                right: 8px;
                bottom: 8px;
                min-width: 24px;
                padding: 2px 6px;
                border-radius: 12px;
                background: rgba(17, 24, 39, 0.75);
                color: #fff;
                font-weight: 600;
                font-size: 12px;
                text-align: center;
              }
            }
          }

          .footer {
            height: 44px;
            margin-top: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
            cursor: pointer;
            font-weight: 600;
            .lock {
              margin-left: 10px;
              max-width: 25px;
            }

            &.locked {
              cursor: not-allowed;
              color: var(--inoperable-color) !important;
            }

            &.is-loading {
              cursor: progress;
              pointer-events: none;
              opacity: 0.9;
            }

            .loading-icon {
              margin-left: 8px;
              font-size: 16px;
            }
          }

          .arrow {
            --arrow-size: 24px;
            position: absolute;
            width: var(--arrow-size);
            height: var(--arrow-size);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: var(--arrow-size);
            color: #333;

            &-right {
              // 居中在列间距中
              right: calc(-1 * (var(--col-gap) / 2 + var(--arrow-size) / 2));
              top: 50%;
              transform: translateY(-50%);
            }

            &-left {
              // 居中在列间距中
              left: calc(-1 * (var(--col-gap) / 2 + var(--arrow-size) / 2));
              top: 50%;
              transform: translateY(-50%);
            }

            &-down {
              // 居中在行间距中
              left: 50%;
              bottom: calc(-1 * (var(--row-gap) / 2 + var(--arrow-size) / 2));
              transform: translateX(-50%);
            }

            .down {
              rotate: 90deg;
            }

            .left {
              rotate: 180deg;
            }
          }

          // 动态箭头动画：根据方向分别轻微位移
          .arrow-right.arrow-nudge {
            animation: arrow-nudge-right 1.6s ease-in-out infinite;
          }

          .arrow-left.arrow-nudge {
            animation: arrow-nudge-left 1.6s ease-in-out infinite;
          }

          .arrow-down.arrow-nudge {
            animation: arrow-nudge-down 1.6s ease-in-out infinite;
          }

          @keyframes arrow-nudge-right {

            0%,
            100% {
              transform: translateY(-50%);
              opacity: 0.9;
            }

            50% {
              transform: translateY(-50%) translateX(8px);
              opacity: 1;
            }
          }

          @keyframes arrow-nudge-left {

            0%,
            100% {
              transform: translateY(-50%);
              opacity: 0.9;
            }

            50% {
              transform: translateY(-50%) translateX(-8px);
              opacity: 1;
            }
          }

          @keyframes arrow-nudge-down {

            0%,
            100% {
              transform: translateX(-50%);
              opacity: 0.9;
            }

            50% {
              transform: translateX(-50%) translateY(8px);
              opacity: 1;
            }
          }

          [data-status="priced"][data-operable="true"],
          [data-status="free"][data-operable="true"] {
            color: var(--operable-color);
          }

          [data-status="priced"][data-operable="false"],
          [data-status="free"][data-operable="false"],
          [data-status="purchased"],
          [data-status="claimed"] {
            color: var(--inoperable-color);
          }
        }
      }
    }
  }

  &.is-mobile {
    .reward-flow {
      --row-gap: 20px;
    }

    .reward-flow .flow-row {
      --col-gap: 20px;
      // 动态卡片宽度：确保两端对齐且列间距固定
      --card-width: calc((100% - (var(--col-gap) * (var(--cols) - 1))) / var(--cols));
      grid-template-columns: repeat(var(--cols), var(--card-width));

      .cell {
        width: 100%;

        .items-scroll {
          &::-webkit-scrollbar {
            display: none;
          }
        }

        .card {
          height: 210px;
          padding: 10px;

          .items-grid {
            --equip-size: 64px;

            .equip {
              .count {
                font-size: 10px;
                right: 0;
                bottom: 0;
              }
              .name {
                font-size: 10px;
              }
            }

            &.once {
              --equip-size: 100px;
            }
          }

          .footer {
            height: 36px;
            margin-top: 12px;
          }

          .arrow {
            --arrow-size: 14px;
          }
        }
      }
    }

    .reward-flow .items-grid {
      // 两列布局下避免横向溢出
      --equip-size: calc((100% - 12px) / 2);
    }

    .reward-flow .arrow {
      --arrow-size: 18px;
    }
  }
}
</style>